import { Button, EmptyState } from '@teach/ui'
import { AlertTriangle } from 'lucide-react'
import { Spinner } from '@/components/common/Spinner'
import { useMessages } from '@/i18n'
import { messages } from './messages'

interface Props {
  isError: boolean
  onRetry: () => void
}

/** Экран до формы статьи: ждём статью и свежий ответ `/moderation` (засев черновика).
 *  На ошибке — повтор, а не форма без черновика: её сохранение стёрло бы черновик. */
export const ArticleLoadGate = ({ isError, onRetry }: Props) => {
  const m = useMessages(messages)
  return isError ? (
    <div className="py-20">
      <EmptyState
        icon={AlertTriangle}
        title={m.loadFailedTitle}
        description={m.loadFailedHint}
        action={
          <Button variant="outline" onClick={onRetry}>
            {m.retry}
          </Button>
        }
      />
    </div>
  ) : (
    <Spinner fullPage />
  )
}
